"use strict";

var debug = require("debug")("knack.formatter.utils");
var _ = require("lodash");
var numberRegex = new RegExp(/[^0-9.-]+/, "g");
var utils = {
  getSolrType: function getSolrType(fieldType, format) {
    var type;
    switch (fieldType) {
      case "currency":
      case "number":
      case "auto_increment":
      case "count":
      case "sum":
      case "min":
      case "max":
      case "average":
      case "timer":
      case "rating":
        type = "number";
        break;
      case "date_time":
        type = "date";
        break;
      case "equation":
        type = "number";
        if (format) {
          var equationType = format.equation_type,
            dateResult = format.date_result;
          if (equationType === "date" && dateResult === "date") {
            type = "date";
          }
        }
        break;
      case "link":
        if (format && format.text_format && (format.text_format === "same" || format.text_format === "unique")) {
          type = "label_text";
        } else {
          type = "url_text";
        }
        break;
      default:
        type = "text";
        break;
    }
    return type;
  },
  // this handles any incoming formats for international commas and decimals and strips those out.
  // should only be used with form inputs, api inputs, and other formatted values
  stripNumber: function stripNumber(field, val, raw) {
    if (!val || val === 0 || _.isNumber(val) || _.isArray(val) && _.isEmpty(val)) {
      return val; // return zeros and blanks
    }
    if (field && field.type && field.type === "timer" && raw) {
      return raw; // timer could have a formatted value like 0.5 hours
    }
    val = String(val);
    var format = field && field.format ? field.format : {};
    var mark_decimal = ".";
    if (format.mark_decimal && format.mark_decimal === "comma" && format.precision) {
      mark_decimal = ",";
    }
    var mark_thousands = ",";
    if (format.mark_thousands && format.mark_thousands !== "none" && format.mark_thousands !== "comma") {
      mark_thousands = format.mark_thousands === "space" ? " " : "\\.";
    }
    if (mark_thousands !== ",") {
      val = val.replace(new RegExp(mark_thousands, "g"), "");
    }
    if (mark_decimal !== ".") {
      val = val.replace(new RegExp(mark_decimal, "g"), ".");
    }
    val = Number(val.replace(numberRegex, ""));
    return val;
  }
};
module.exports = utils;